import { Component, DestroyRef, EventEmitter, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-gdo-terms-of-use-webview',
    templateUrl: './gdo-terms-of-use-webview.component.html',
    styleUrls: ['./gdo-terms-of-use-webview.component.scss'],
    standalone: false
})
export class GdoTermsOfUseWebviewComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  onTermsAccepted = new EventEmitter();
  hideCancelButton: Boolean = true;
  termsAndCondition: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GdoTermsOfUseWebviewComponent>,
    private appService: AppService
  ) {}
  ngOnInit(): void {
    this.appService.TcContent(null).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res) => {
        this.hideCancelButton = false;
        if (res) {
          const document = new DOMParser().parseFromString(res, 'application/xml');
          this.termsAndCondition = document.getElementsByTagName('content')[0]?.textContent ?? '';
        }
      },
      (err) => {
        this.hideCancelButton = false;
      }
    );
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAccept(): void {
    this.dialogRef.close();
    this.onTermsAccepted.emit();
  }

  onClickClose() {
    this.dialogRef.close();
  }
}
